// extracted by mini-css-extract-plugin
export default {"content":"product-terms-consent-modal_content__QgTk4","button":"product-terms-consent-modal_button__f+igx"};